/* istanbul ignore file */
/* eslint-disable */

import * as React from 'react'
import OutlinedInput from '@mui/material/OutlinedInput'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { type SelectChangeEvent } from '@mui/material/Select'
import { TextField } from '@mui/material'

export interface Option {
  value: string
  label: string
}
interface GenericDropdownProps {
  options: Option[]
  value: string
  onChange: (event: SelectChangeEvent<string>) => void
  label: string
  width: string | number | undefined
  dataTestId: string
  allowInput?: boolean
  setState?: React.Dispatch<React.SetStateAction<string>> | undefined
}

const injectLabel = (label: string): JSX.Element => {
  return <span style={{ fontSize: '15px', paddingBottom: 10 }}>{label}</span>
}

const truncateLabel = (label: string, maxLength: number) => {
  if (label.length > maxLength) {
    return label.slice(0, maxLength) + '...';
  }
  return label;
}

export const GenericDropdown: React.FC<GenericDropdownProps> = ({ options, value, onChange, label, width, dataTestId, allowInput = false, setState }) => {
  const [search, setSearch] = React.useState('')
  const [filteredOptions, setFilteredOptions] = React.useState<Option[]>(options)

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSearch(event.target.value)
    setFilteredOptions(options.filter((option) => option.label.toLowerCase().includes(event.target.value.toLowerCase())))
  }

  const handleReset = (event: SelectChangeEvent<string>): void => {
    setSearch('')
    setFilteredOptions(options)
    onChange(event)
  }

  const handleClose = (event: React.SyntheticEvent<Element, Event>): void => {
    setSearch('')
    setFilteredOptions(options)
  }

  React.useEffect(() => {
    setFilteredOptions(options.filter((option) => option.label?.toLowerCase().includes(search.toLowerCase())))
  }, [options, search])

  const textStyle = {
    root: {
      backgroundColor: '#272727',
      width: '100%',
      '& .MuiInputBase-input': {
        color: '#F0F0F0',
        backgroundColor: '#404040',
        height: '30px',
        paddingLeft: '10px',
        borderRadius: '0px'
      },
      '& .MuiInputLabel-root': {
        color: '#F0F0F0',
        '&.Mui-focused': {
          color: '#F0F0F0'
        }
      },
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: '#00000000'
        },
        '&:hover fieldset': {
          borderColor: '#00000000'
        },
        '&.Mui-focused fieldset': {
          borderColor: '#00000000'
        }
      }
    }
  }
  return (
    <div className='genericDropdownDiv'>
      <FormControl>
        {label !== '' && injectLabel(label)}
        <Select
          className='generic-dropdown'
          required
          onKeyDownCapture={(event) => { event.stopPropagation() }}
          value={value}
          displayEmpty
          data-testid={dataTestId}
          label={dataTestId}
          // inputProps={{ "data-testid": dataTestId }}
          onChange={handleReset}
          onClose={handleClose}
          aria-label={dataTestId}
          renderValue={(selectedValue) =>
            truncateLabel(
              options.find((option) => option.value === selectedValue)?.label || 'Select an option',
              28
            )
          }
          input={<OutlinedInput />}
          sx={{

            background: '#303030',
            width: width !== undefined ? width : '260px', height: '40px',
            boxShadow: '1px 1px 1px 0px #0000004D',
            color: '#f0f0f0', fontFamily: 'Honeywell Sans Web', fontSize: '14px',
            borderRadius: '4px',
            '& .MuiInputBase-root':{
              marginTop:'10px'
            }
          }}
          disableUnderline
        >
          {allowInput && (<TextField
              variant="standard"
              id='standard-basic'
              placeholder='Search'
              value={search}
              onChange={handleSearch}
              InputLabelProps={{
                disabled: true
              }}
              size='small'
              className='custom-textfield'
              sx={
                textStyle.root
              }
            />)}
          {
            filteredOptions.map((option, index) => (
              <MenuItem data-testid={`${dataTestId}-${index}`} key={index} value={option.value}>
                {option.label}
              </MenuItem>
            ))
          }
        </Select>
      </FormControl>
    </div>
  )
}
